

export { CTopFooterLinks } from '../../fragments/c-top-footer-links'
